import { useLayoutContext } from '@/context/layout'
import { useMixpanel } from '@/context/mixpanel'
import { cn } from '@/utils/cn'
import { Button } from '../common/button'
import { ArrowsInwardsOutwardsIcon } from '../icons/arrowsInwardsOutwards'

export const ExpandNavigationButton = () => {
  const { trackEvent } = useMixpanel()
  const { isNavbarPinned, setNavbarPinned, setNavbarPointerPreviewed } = useLayoutContext()

  const handleExpanded = () => {
    const nextPinned = !isNavbarPinned

    trackEvent('Side navigation size toggle', { Action: nextPinned ? 'Open' : 'Close' })
    setNavbarPinned(nextPinned)

    if (!nextPinned) {
      setNavbarPointerPreviewed(false)
    }
  }

  return (
    <Button variant="default" size="default" className={cn('h-6 w-fit rounded-full')} onClick={handleExpanded}>
      <div className="w-6 min-w-6 overflow-hidden">
        <ArrowsInwardsOutwardsIcon inwards={isNavbarPinned} size={24} />
      </div>
      <p className={cn('sr-only')}>{isNavbarPinned ? 'Collapse' : 'Expand'} sidebar</p>
    </Button>
  )
}
